const moment = require('moment');
import _ from 'lodash';

export default {
  data() {
    return {
      conditions: [
        {dayDiff: 7, star: 1, grade: 3},
        {dayDiff: 8, star: 1, grade: 4},
        {dayDiff: 9, star: 1, grade: 5},
        {dayDiff: 10, star: 2, grade: 3},
        {dayDiff: 11, star: 2, grade: 4},
        {dayDiff: 12, star: 2, grade: 5},
        {dayDiff: 13, star: 3, grade: 3},
        {dayDiff: 14, star: 3, grade: 4},
        {dayDiff: 15, star: 3, grade: 5},
      ]
    }
  },
  methods: {
    canPressReservationBtn: function (dayDiff) {
      const found = this.conditions.find(e => e.dayDiff === dayDiff);
      const siteMemberStar = Number(this.$store.state.siteMemberData.star);
      const siteMemberGrade = this.$store.state.siteMemberData.gradeId;
      // 7日間は誰でも予約可能
      if (dayDiff <= 6) return true;
      // 16日後は予約不可
      if (dayDiff > 15 || !found) return false;
      // グレード3未満は予約不可
      if (siteMemberGrade < 3) return false;
      // スターを満たしていれば、グレードに関係なく予約可
      if (siteMemberStar > found.star) {
        return true;
      }
      if (siteMemberStar === found.star) {
        if (siteMemberGrade >= found.grade) return true;
      }
      return false;
    },
    getStarGradeCondition: function (dayDiff) {
      return this.conditions.find(e => e.dayDiff === dayDiff);
    },
    getDiffDay: function (date) {
      const dayObj = moment(date);
      let diff = dayObj.diff(moment(), "days") + 1;
      if (moment().format("HH") < 6) {
        diff = dayObj.diff((moment().add(-1, "days")), "days") + 1;
      }
      return diff;
    },
    // diffDay日後に予約可能なstarとグレードを返す
    getStarMinGradeSet(diffDay) {
      console.log(diffDay);
      switch(diffDay) {
        case 7:
          return [
            { star: 3, minGrade: 3 },
            { star: 2, minGrade: 3 },
            { star: 1, minGrade: 3 }
          ];
        case 8:
          return [
            { star: 3, minGrade: 3 },
            { star: 2, minGrade: 3 },
            { star: 1, minGrade: 4 }
          ];
        case 9:
          return [
            { star: 3, minGrade: 3 },
            { star: 2, minGrade: 3 },
            { star: 1, minGrade: 5 }
          ];
        case 10:
          return [
            { star: 3, minGrade: 3 },
            { star: 2, minGrade: 3 }
          ];
        case 11:
          return [
            { star: 3, minGrade: 3 },
            { star: 2, minGrade: 4 }
          ];
        case 12:
          return [
            { star: 3, minGrade: 3 },
            { star: 2, minGrade: 5 }
          ];
        case 13:
          return [
            { star: 3, minGrade: 3 }
          ];
        case 14:
          return [
            { star: 3, minGrade: 4 }
          ];
        case 15:
          return [
            { star: 3, minGrade: 5 }
          ];
        default:
          return [];
      }
    }
  }
}